export enum EquipmentAlarmRuleSelectionType {
  LABEL = 'LABEL',
  EQUIPMENT_TYPE = 'EQUIPMENT_TYPE',
  ALL_EQUIPMENT = 'ALL_EQUIPMENT',
  EQUIPMENT = 'EQUIPMENT',
  CUSTOMER = 'CUSTOMER',
  EQUIPMENT_STATUS = 'EQUIPMENT_STATUS',
}

export function getEquipmentSelectionForOwnEquipments(): EquipmentAlarmRuleSelectionType[] {
  return [
    EquipmentAlarmRuleSelectionType.LABEL,
    EquipmentAlarmRuleSelectionType.EQUIPMENT_TYPE,
    EquipmentAlarmRuleSelectionType.ALL_EQUIPMENT,
    EquipmentAlarmRuleSelectionType.EQUIPMENT,
    EquipmentAlarmRuleSelectionType.EQUIPMENT_STATUS,
  ];
}

export function getEquipmentSelectionForOwnAndSharedEquipments(): EquipmentAlarmRuleSelectionType[] {
  return [...getEquipmentSelectionForOwnEquipments(), EquipmentAlarmRuleSelectionType.CUSTOMER];
}
